import { useState } from 'react';
import SelectElement from '../../../../../components/forms/SelectElement';
import Modal from '../../../../../components/modals/Modal';
import EditCard from '../EditCard';
import type {
	Category,
	Question as IQuestion,
	SubCategory
} from '../../../../../data/interface-question';
import type { QuestionBankID } from '../../../../../data/interface-question-bank';
import type { OptionObjMustHaves } from '../../../../../data/interface-utils';

interface QuestionProps {
	categories: Category[];
	question: IQuestion;
	questionBankID: QuestionBankID;
	onUpdate: (
		questionID: string,
		key: string,
		newValue: any
	) => Promise<IQuestion | null>;
}

const ViewEditSubCategoryList = ({
	categories,
	question,
	questionBankID,
	onUpdate
}: QuestionProps) => {
	const [edit, setEdit] = useState(false);
	const [subCategory, setSubCategory] = useState<string | undefined>(
		question.subCategoryList ?? undefined
	);

	const handleUpdate = () => {
		onUpdate(question.id, 'subCategoryList', subCategory)
			.then(() => setEdit(false))
			.catch((error) => console.error('Error updating question:', error));
	};

	const loadSubCategories = (): OptionObjMustHaves[] => {
		const sCO: OptionObjMustHaves[] = [];
		const subCategories = categories
			?.filter((c) => c.questionBank === questionBankID)
			.find((c) => c.id === question.categoryID)?.subCategoryList;
		if (subCategories !== undefined) {
			subCategories.map((sc: SubCategory) => {
				return sCO.push({
					id: sc.name.toLowerCase(),
					value: sc.name
				});
			});
		}
		return sCO;
	};

	return (
		<>
			<EditCard label='Sub Categoría' onEdit={setEdit}>
				{subCategory === undefined
					? 'No hay sub categoría elegida'
					: subCategory}
			</EditCard>

			<Modal
				actionBtnText='Actualizar'
				handleAction={handleUpdate}
				headline='Actualiza la Pregunta'
				isOpen={edit}
				onClose={() => setEdit(false)}
				showCloseBtn={true}>
				<SelectElement
					defaultOption='Elige una subcategoría'
					icon='ballot'
					iconFam='material-icons'
					id='subCategoryList'
					isDefaultOptionDisabled={false}
					label='Elige una subcategoría'
					options={loadSubCategories()}
					value={subCategory}
					handleChange={(v) => {
						setSubCategory(v);
					}}
				/>
			</Modal>
		</>
	);
};
export default ViewEditSubCategoryList;
